import React, { FC } from 'react';
import tableNames from 'constants/tableNames';
import PageTemplate from 'components/pageTemplate/PageTemplate';
import { Column, Row } from 'components/ui/table';
import DataListContainer from '../../components/dataListContainer/DataListContainer';
import { AnyObject } from '../../types/Common';
import ItemConfiguration from '../../types/ItemConfiguration';
import TopPanelContainer from '../../components/topPanel/TopPanelContainer';
import Button from '../../components/ui/button';
import { getList } from '../../api/internalDomain';
import { useTranslation } from '../../hooks';
import Loader from '../../components/ui/loader';

interface Props {
  configuration: ItemConfiguration[];
  onEdit: (data: AnyObject) => void;
  onDelete: (id: number, domain: string) => void;
  isLoading: boolean;
}

export const InternalDomain: FC<Props> = (props) => {
  const { configuration, onEdit, onDelete, isLoading } = props;
  const getTranslate = useTranslation();

  const renderRow = (data) => {
    return (
      <Row customClass='page-icons__table-row'>
        {
          configuration.map((column) => {
            const { id } = column;
            let content = data[id];

            if (id === 'edit') {
              content = (
                <>
                  <Button
                    icon='im-Edit1'
                    status='text'
                    size='inline'
                    customClass='page-team__edit-btn'
                    onClick={() => onEdit(data)}
                  />
                  <Button
                    icon='im-Basket'
                    status='text'
                    size='inline'
                    customClass='page-team__edit-btn'
                    onClick={() => onDelete(data.id, data.domain)}
                  />
                </>
              );
            }

            return (
              <Column
                columnWidths={data.columnWidths}
                key={id}
                id={id}
                content={content || '–'}
                customClass={`ui-table__column_${id}`}
              />
            );
          })
        }
      </Row>
    );
  };
  const button = (): React.JSX.Element => {
    // @ts-ignore
    return (
      <Button
        onClick={() => onEdit({})}
        text={getTranslate('internalDomain.table.addNew')}
      />
    );
  }
  // @ts-ignore
  return (
    <PageTemplate.Main customClass='page-internal-domains'>
      <PageTemplate.Container>
        <TopPanelContainer
          name={'internalDomains'}
          filtersConfig={false}
          button={button()}
        />

        <DataListContainer
          minColumnsWidth={{ id: 200, domain: 300 }}
          tableName={tableNames.internalDomains}
          customClass='table-icons'
          apiRequest={getList}
          rowRender={renderRow}
        />
        {isLoading && <Loader />}
      </PageTemplate.Container>
    </PageTemplate.Main>
  );
};

